<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img style="width: 250px; height: 130px;" :src="config.imageUrl + companyInfo.logoUrl" alt="公司Logo">
        </router-link>
      </div>
      <nav class="navbar">
        <ul class="nav-list">
          <li v-for="item in navItems" :key="item.path">
            <router-link :to="item.path" class="nav-item" :class="{ active: isActive(item.path) }">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="mobile-toggle" @click="toggleMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
</template>

<script setup>
import { getCompanyInfo } from '@/utils/constant'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import config from '@/config'
const route = useRoute()
const isMobileMenuOpen = ref(false)
const companyInfo = ref({}) 
getCompanyInfo().then(res => {
  companyInfo.value = res
})

const navItems = [
  { path: '/', name: '首页' },
  { path: '/about', name: '关于我们' },
  // { path: '/products', name: '产品中心' },
  { path: '/applications', name: '场景应用' },
  // { path: '/join', name: '加入我们' },
  // { path: '/news', name: '新闻资讯' }
]


const isActive = (path) => {
  return route.path === path
}

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const handleImageError = (e) => {
  e.target.src = 'https://via.placeholder.com/150x50?text=企业Logo'
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(135deg, #3498db, #2c3e50);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
  }

  .logo {
    img {
      height: 50px;
      width: auto;
    }
  }

  .navbar {
    .nav-list {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;

      .nav-item {
        padding: 8px 16px;
        text-decoration: none;
        color: white;
        font-size: 16px;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover, &.active {
          background: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }
      }
    }
  }

  .mobile-toggle {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 20px;
    cursor: pointer;

    span {
      display: block;
      width: 100%;
      height: 2px;
      background-color: white;
      transition: all 0.3s ease;
    }
  }
}

@media (max-width: 768px) {
  .header {
    .navbar {
      display: none;
    }

    .mobile-toggle {
      display: flex;
    }
  }
}
</style> 